import { render } from "./SectionGenerateInvoice.vue?vue&type=template&id=2a3e8e6f"
import script from "./SectionGenerateInvoice.vue?vue&type=script&lang=js"
export * from "./SectionGenerateInvoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__